import { render } from "./CategoryTopSheet.vue?vue&type=template&id=6ac36527"
import script from "./CategoryTopSheet.vue?vue&type=script&lang=js"
export * from "./CategoryTopSheet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__